"use strict";

/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelfcareService = void 0;
const Interfaces_1 = require("../Interfaces");
var SelfcareService;
(function (SelfcareService) {
  /**
   * @title YOL Service
   * @version 3.21.2
   * @license MIT
   * @baseUrl /selfcare
   * @contact YOL Digital <digital-yol@sunrise.net>
   *
   * YOL Selfcare APis [ 📜 View Changelog](/selfcare/internal/release-note)
   */
  class Api {
    constructor(url, http) {
      this.public = {
        /**
        * No description
        *
        * @tags public
        * @name Account
        * @request GET:/selfcare/account
        * @secure bearerAuth
        * @response `200` `AccountResp` Ok
        * @response `400` `{
        error: "ERR_BRAND_KEY_IS_MISSING",
             }`
        * @response `404` `{
        error: "ERR_ACCOUNT_NOT_FOUND",
             }`
        */
        account: (params = {}) => this.http.request("GET", `${this.url}/selfcare/account`, {
          ...params
        }),
        /**
        * No description
        *
        * @tags public
        * @name GetDocuments
        * @request GET:/selfcare/documents
        * @secure bearerAuth
        * @response `200` `(DocumentResp)[]` Ok
        * @response `400` `{
        error: "ERR_BAD_REQUEST",
             }`
        * @response `404` `{
        error: "ERR_SUBSCRIPTION_NOT_FOUND",
             }`
        * @response `500` `{
        error: "ERR_SYSTEM_ERROR",
             }`
        */
        getDocuments: (query, params = {}) => this.http.request("GET", `${this.url}/selfcare/documents`, {
          params: query,
          ...params
        }),
        /**
        * No description
        *
        * @tags public
        * @name GetDocumentById
        * @request GET:/selfcare/documents/download/{id}
        * @secure bearerAuth
        * @response `200` `DownloadDocumentResp` Ok
        * @response `400` `{
        error: "ERR_BAD_REQUEST",
             }`
        * @response `404` `{
        error: "ERR_DOCUMENT_NOT_FOUND",
             }`
        * @response `500` `{
        error: "ERR_SYSTEM_ERROR" | "ERR_FETCH_DOCUMENT_FAILED",
             }`
        */
        getDocumentById: (id, params = {}) => this.http.request("GET", `${this.url}/selfcare/documents/download/${id}`, {
          ...params
        }),
        /**
        * No description
        *
        * @tags public
        * @name UpdateOtoId
        * @request POST:/selfcare/subscription/{id}/order/update/otoId
        * @secure bearerAuth
        * @response `204` `void` No content
        * @response `400` `{
        error: "ERR_OTOID_VALIDATION_FAILED",
             }`
        * @response `404` `{
        error: "ERR_ACCOUNT_NOT_FOUND" | "ERR_SUBSCRIPTION_NOT_FOUND" | "ERR_ORDER_NOT_FOUND",
             }`
        * @response `500` `{
        error: "ERR_SYSTEM_ERROR" | "ERR_UPDATE_OTOID_FAILED",
             }`
        */
        updateOtoId: (id, data, params = {}) => this.http.request("POST", `${this.url}/selfcare/subscription/${id}/order/update/otoId`, {
          body: data,
          headers: {
            "Content-Type": Interfaces_1.ContentType.Json
          },
          ...params
        }),
        /**
        * No description
        *
        * @tags public
        * @name UpdateShippingAddress
        * @request POST:/selfcare/subscription/{id}/order/update/shippingAddress
        * @secure bearerAuth
        * @response `204` `void` No content
        * @response `404` `{
        error: "ERR_ACCOUNT_NOT_FOUND" | "ERR_SUBSCRIPTION_NOT_FOUND" | "ERR_ORDER_NOT_FOUND",
             }`
        * @response `500` `{
        error: "ERR_SYSTEM_ERROR" | "ERR_UPDATE_SHIPPING_ADDRESS_FAILED",
             }`
        */
        updateShippingAddress: (id, data, params = {}) => this.http.request("POST", `${this.url}/selfcare/subscription/${id}/order/update/shippingAddress`, {
          body: data,
          headers: {
            "Content-Type": Interfaces_1.ContentType.Json
          },
          ...params
        }),
        /**
        * No description
        *
        * @tags public
        * @name RetriggerShipment
        * @request POST:/selfcare/subscription/{id}/order/update/retrigger-shipment
        * @secure bearerAuth
        * @response `204` `void` No content
        * @response `400` `{
        error: "ERR_WRONG_SOURCE",
             }`
        * @response `403` `{
        error: "ERR_INVALID_BRANDKEY",
             }`
        * @response `404` `{
        error: "ERR_ACCOUNT_NOT_FOUND" | "ERR_SUBSCRIPTION_NOT_FOUND" | "ERR_ORDER_NOT_FOUND",
             }`
        * @response `500` `{
        error: "ERR_SYSTEM_ERROR" | "ERR_UPDATE_SHIPPING_ADDRESS_FAILED" | "ERR_FROM_CRM",
             }`
        * @response `504` `{
        error: "ERR_API_TIMEOUT",
             }`
        */
        retriggerShipment: (id, data, params = {}) => this.http.request("POST", `${this.url}/selfcare/subscription/${id}/order/update/retrigger-shipment`, {
          body: data,
          headers: {
            "Content-Type": Interfaces_1.ContentType.Json
          },
          ...params
        }),
        /**
        * No description
        *
        * @tags public
        * @name RetriggerPoaPdf
        * @request POST:/selfcare/subscription/{id}/order/update/retrigger-poa-pdf
        * @secure bearerAuth
        * @response `204` `void` No content
        * @response `400` `{
        error: "ERR_INVALID_BRANDKEY" | "ERR_WRONG_SIGNATURE_FORMAT" | "ERR_ACTIVE_NP_FLOW_REQUEST_NOT_FOUND" | "ERR_INVALID_SUBSCRIPTION_STATUS",
             }`
        * @response `403` `{
        error: "ERR_INVALID_BRANDKEY",
             }`
        * @response `404` `{
        error: "ERR_ACCOUNT_NOT_FOUND" | "ERR_SUBSCRIPTION_NOT_FOUND",
             }`
        * @response `500` `{
        error: "ERR_SYSTEM_ERROR" | "ERR_FROM_API",
             }`
        */
        retriggerPoaPdf: (id, data, params = {}) => this.http.request("POST", `${this.url}/selfcare/subscription/${id}/order/update/retrigger-poa-pdf`, {
          body: data,
          headers: {
            "Content-Type": Interfaces_1.ContentType.Json
          },
          ...params
        }),
        /**
        * No description
        *
        * @tags public
        * @name Subscriptions
        * @request GET:/selfcare/subscriptions
        * @secure bearerAuth
        * @response `200` `(SubscriptionsResp)[]` Ok
        * @response `400` `{
        error: "ERR_BRAND_KEY_IS_MISSING",
             }`
        * @response `404` `{
        error: "ERR_SUBSCRIPTION_NOT_FOUND",
             }`
        */
        subscriptions: (params = {}) => this.http.request("GET", `${this.url}/selfcare/subscriptions`, {
          ...params
        }),
        /**
        * No description
        *
        * @tags public
        * @name Subscription
        * @request GET:/selfcare/subscription/{id}
        * @secure bearerAuth
        * @response `200` `SubscriptionResp` Ok
        * @response `400` `{
        error: "ERR_BRAND_KEY_IS_MISSING",
             }`
        * @response `404` `{
        error: "ERR_SUBSCRIPTION_NOT_FOUND",
             }`
        */
        subscription: (id, params = {}) => this.http.request("GET", `${this.url}/selfcare/subscription/${id}`, {
          ...params
        }),
        /**
        * No description
        *
        * @tags public
        * @name SubscriptionOrders
        * @request GET:/selfcare/subscription/{id}/orders
        * @secure bearerAuth
        * @response `200` `(OrderResp)[]` Ok
        * @response `400` `{
        error: "ERR_BRAND_KEY_IS_MISSING",
             }`
        * @response `404` `{
        error: "ERR_ORDER_NOT_FOUND" | "ERR_SUBSCRIPTION_NOT_FOUND",
             }`
        * @response `500` `{
        error: "ERR_FROM_API" | "ERR_SYSTEM_ERROR",
             }`
        */
        subscriptionOrders: (id, params = {}) => this.http.request("GET", `${this.url}/selfcare/subscription/${id}/orders`, {
          ...params
        }),
        /**
        * No description
        *
        * @tags public
        * @name FetchFixnetDetails
        * @request GET:/selfcare/subscription/{id}/fixnet-details
        * @secure bearerAuth
        * @response `200` `FixnetDetailResp` Ok
        * @response `404` `{
        error: "ERR_SUBSCRIPTION_NOT_FOUND",
             }`
        * @response `500` `{
        error: "ERR_SYSTEM_ERROR" | "ERR_FROM_API",
             }`
        */
        fetchFixnetDetails: (id, params = {}) => this.http.request("GET", `${this.url}/selfcare/subscription/${id}/fixnet-details`, {
          ...params
        }),
        /**
        * No description
        *
        * @tags public
        * @name FetchSimDetails
        * @request GET:/selfcare/subscription/{id}/sim-details
        * @secure bearerAuth
        * @response `200` `SimDetailsResp` Ok
        * @response `404` `{
        error: "ERR_NOT_FOUND",
             }`
        * @response `500` `{
        error: "ERR_SYSTEM_ERROR" | "ERR_FROM_API",
             }`
        */
        fetchSimDetails: (id, params = {}) => this.http.request("GET", `${this.url}/selfcare/subscription/${id}/sim-details`, {
          ...params
        }),
        /**
        * No description
        *
        * @tags public
        * @name Users
        * @request GET:/selfcare/users
        * @secure bearerAuth
        * @response `200` `(Users)[]` Ok
        * @response `400` `{
        error: "ERR_HEALTHCHECK_FAILED",
             }`
        */
        users: (params = {}) => this.http.request("GET", `${this.url}/selfcare/users`, {
          ...params
        }),
        /**
        * No description
        *
        * @tags public
        * @name User
        * @request GET:/selfcare/user/{id}
        * @secure bearerAuth
        * @response `200` `UserResp` Ok
        * @response `400` `{
        error: "ERR_BRAND_KEY_IS_MISSING",
             }`
        * @response `404` `{
        error: "ERR_USER_NOT_FOUND",
             }`
        */
        user: (id, params = {}) => this.http.request("GET", `${this.url}/selfcare/user/${id}`, {
          ...params
        }),
        /**
        * No description
        *
        * @tags public
        * @name UpdateContactDetails
        * @request POST:/selfcare/user/update/contact-details
        * @secure bearerAuth
        * @response `204` `void` No content
        * @response `400` `{
        error: "ERR_BAD_REQUEST",
             }`
        * @response `404` `{
        error: "ERR_ACCOUNT_NOT_FOUND",
             }`
        * @response `500` `{
        error: "ERR_UPDATE_USER_FAILED",
             }`
        */
        updateContactDetails: (data, params = {}) => this.http.request("POST", `${this.url}/selfcare/user/update/contact-details`, {
          body: data,
          headers: {
            "Content-Type": Interfaces_1.ContentType.Json
          },
          ...params
        }),
        /**
        * No description
        *
        * @tags public
        * @name UpdateEmail
        * @request POST:/selfcare/update/email
        * @secure bearerAuth
        * @response `200` `({
        refId?: string,
             })` Ok
        * @response `400` `{
        error: "ERR_BAD_REQUEST" | "ERR_CONFIRM_WITH_REQUIRED" | "ERR_INVALID_METHOD",
             }`
        * @response `404` `{
        error: "ERR_ACCOUNT_NOT_FOUND",
             }`
        * @response `500` `{
        error: "ERR_UPDATE_USER_EMAIL_FAILED" | "ERR_FROM_API",
             }`
        */
        updateEmail: (data, params = {}) => this.http.request("POST", `${this.url}/selfcare/update/email`, {
          body: data,
          headers: {
            "Content-Type": Interfaces_1.ContentType.Json
          },
          ...params
        }),
        /**
        * No description
        *
        * @tags public
        * @name ConfirmEmail
        * @request POST:/selfcare/update/confirm-email
        * @secure bearerAuth
        * @response `204` `void` No content
        * @response `400` `{
        error: "ERR_BAD_REQUEST" | "ERR_INVALID_CODE" | "ERR_MAX_REACHED" | "ERR_CODE_HAS_EXPIRED",
             }`
        * @response `404` `{
        error: "ERR_ACCOUNT_NOT_FOUND",
             }`
        * @response `429` `{
        error: "ERR_MAX_REACHED",
             }`
        * @response `500` `{
        error: "ERR_SYSTEM_ERROR",
             }`
        */
        confirmEmail: (data, params = {}) => this.http.request("POST", `${this.url}/selfcare/update/confirm-email`, {
          body: data,
          headers: {
            "Content-Type": Interfaces_1.ContentType.Json
          },
          ...params
        }),
        /**
        * No description
        *
        * @tags public
        * @name UpdateBillingAddress
        * @request POST:/selfcare/user/update/billing-address
        * @secure bearerAuth
        * @response `204` `void` No content
        * @response `400` `{
        error: "ERR_BAD_REQUEST",
             }`
        * @response `404` `{
        error: "ERR_ACCOUNT_NOT_FOUND",
             }`
        * @response `500` `{
        error: "ERR_UPDATE_USER_FAILED",
             }`
        */
        updateBillingAddress: (data, params = {}) => this.http.request("POST", `${this.url}/selfcare/user/update/billing-address`, {
          body: data,
          headers: {
            "Content-Type": Interfaces_1.ContentType.Json
          },
          ...params
        })
      };
      this.http = http;
      this.url = url;
    }
  }
  SelfcareService.Api = Api;
})(SelfcareService || (exports.SelfcareService = SelfcareService = {}));